import "core-js/modules/es6.string.link";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

export default {
  name: "MobileUserTypes",
  props: {
    typesList: {
      type: Array,
      default: function _default() {
        return [];
      }
    }
  },
  computed: {
    cssVars: function cssVars() {
      return {
        "--mut-spacing": "16px",
        "--mut-radius": "12px",
        "--mut-font-base": "14px",
        "--mut-text": "#1a1a2e",
        "--mut-primary-light": "#e8f0fe",
        "--mut-shadow": "0 2px 12px 0 rgba(10, 61, 145, 0.08)",
        "--mut-padding-top": "16px",
        "--mut-gap": "10px",
        "--mut-item-gap": "8px",
        "--mut-item-padding-y": "14px",
        "--mut-item-padding-x": "8px",
        "--mut-icon-wrap-size": "48px",
        "--mut-icon-wrap-radius": "12px",
        "--mut-icon-size": "28px",
        "--mut-name-font-size": "13px"
      };
    }
  },
  methods: {
    getTypeIcon: function getTypeIcon(type) {
      try {
        return require("@/assets/newimg/types_".concat(type, ".png"));
      } catch (e) {
        return "";
      }
    },
    handleClick: function handleClick(item) {
      if (!item.link) {
        // 社会学习者跳转社区教育
        if (item.type === "shxz") {
          this.$router.push("/communityEducation");
        }
        return;
      }
      this.$router.push(item.link);
    }
  }
};